import { render, staticRenderFns } from "./StudentImageUpload.vue?vue&type=template&id=e798c522&scoped=true"
import script from "./StudentImageUpload.vue?vue&type=script&lang=js"
export * from "./StudentImageUpload.vue?vue&type=script&lang=js"
import style0 from "./StudentImageUpload.vue?vue&type=style&index=0&id=e798c522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e798c522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VChip,VFileInput,VForm})
